import {
  and,
  getDocs,
  orderBy,
  query,
  QueryFieldFilterConstraint,
  where,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { relationshipConverter } from './converters/relationships';
import { CollectionOptions, getAuthentication, getCollection } from './helpers';

export type Options = {
  ids?: ID[];
};

export const getRelationships = async (options: Options = {}) => {
  const auth = await getAuthentication();

  const conditions = [
    where('roles.all', 'array-contains', auth.currentUser?.uid),

    !!options.ids?.length && where('id', 'in', options.ids),
  ].filter(Boolean) as QueryFieldFilterConstraint[];

  return query(
    getCollection(CollectionOptions.Relationships).withConverter(
      relationshipConverter,
    ),
    and(...conditions),
    orderBy('createdAt', 'asc'),
  );
};

export const getRelationshipDocs = async (options?: Options) => {
  const query = await getRelationships(options);
  const relationships = await getDocs(query);

  return relationships.docs.map((doc) => doc.data());
};
